import http from "./http";

export type CountryRatesPayload = {
	columns: string[];
	rows: Array<Record<string, any>>;
	updatedAt?: string;
};

export async function getCountryRates(): Promise<CountryRatesPayload> {
	const { data } = await http.get(`/utility/country-rates`);
	return data?.data || { columns: [], rows: [] };
}

export async function saveCountryRates(payload: CountryRatesPayload) {
	const { data } = await http.post(`/utility/country-rates`, {
		data: payload,
	});
	return data;
}

export async function getCountryOptions(): Promise<string[]> {
	const { data } = await http.get(`/utility/country-options`);
	const countries = data?.data?.countries;
	return Array.isArray(countries) ? countries : [];
}
